import script from "./GerenciadorLayoutModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GerenciadorLayoutModal.vue?vue&type=script&setup=true&lang=js"

import "./GerenciadorLayoutModal.vue?vue&type=style&index=0&id=2d3c45d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d3c45d3"]])

export default __exports__